/**
 * GA4 Event Tracking Utilities
 * Measurement ID: G-MSDEL9DBQN
 */
const gtag = (...args) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};

/**
 * Evento: Visualização de produto (view_item)
 * Disparar quando o usuário abre a página de um produto.
 */
export const trackViewItem = ({ id, name, price, category, partner }) => {
  gtag('event', 'view_item', {
    currency: 'BRL',
    value: price || 0,
    items: [{
      item_id: id,
      item_name: name,
      item_category: category || 'Peças',
      item_brand: partner || 'Rocha Climatização',
      price: price || 0,
      quantity: 1,
    }],
  });
};

/**
 * Evento: Início de checkout (begin_checkout)
 * Disparar quando o usuário acessa a página de checkout.
 */
export const trackBeginCheckout = ({ items, total, partner }) => {
  gtag('event', 'begin_checkout', {
    currency: 'BRL',
    value: total || 0,
    items: (items || []).map((item) => ({
      item_id: item.id || item.product_id,
      item_name: item.name,
      item_category: 'Peças',
      item_brand: partner || 'Rocha Climatização',
      price: item.price || 0,
      quantity: item.quantity || 1,
    })),
  });
};

/**
 * Evento: Compra concluída (purchase)
 * Disparar quando o pagamento é confirmado (status = sucesso/aprovado).
 */
export const trackPurchase = ({ orderId, items, total, partner }) => {
  gtag('event', 'purchase', {
    transaction_id: orderId,
    currency: 'BRL',
    value: total || 0,
    items: (items || []).map((item) => ({
      item_id: item.id || item.product_id,
      item_name: item.name,
      item_category: 'Peças',
      item_brand: partner || 'Rocha Climatização',
      price: item.price || 0,
      quantity: item.quantity || 1,
    })),
  });
};
